import { createSystem, defaultConfig } from '@chakra-ui/react';
import { ROCKET_THEME_LEGACY_ROOT_CONFIG } from '@rocket/ui';

import { BB_THEME_CONFIG } from './bbThemeConfig';

/**
 * bbcedit's Chakra system: rocket's legacy-root config (preflight off + rem
 * tokens scaled for the 62.5% html font-size) composed with the BlackBoiler
 * brand fragment.
 *
 * `createSystem` is variadic and merges, so the host-specific bits
 * (preflight/rem-scaling) and the portable brand bits stay separate. word-plugin
 * would compose the SAME fragment against the normal root:
 *
 *   createSystem(defaultConfig, { theme: BB_THEME_CONFIG })
 *
 * which is why BB_THEME_CONFIG must stay px-authored and free of any
 * preflight/scaling concerns — see the rules in bbThemeConfig.ts.
 */
export const BB_THEME = createSystem(defaultConfig, ROCKET_THEME_LEGACY_ROOT_CONFIG, {
  theme: BB_THEME_CONFIG,
});
